import React, { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
    PrimaryButton,
    Spinner,
    SpinnerSize,
    TextField,
} from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { handleDocument } from './signingHelper';
import './DocumentSigning.scss';
import { ServiceCreator as TaxpayerProxy } from '../SignUp/Service/client';
import { GetSignableDataDto, SignInfo } from '../SignUp/Service/TaxpayerProxy';

export interface Props {
    hidden: boolean;
    content: string[];
    onSign: (signature: string) => void;
    disabled?: boolean;
    isLoading?: boolean;
}

declare global {
    interface Window {
        signResult: string;
    }
}
export const DocumentSigning: FC<Props> = (props: Props) => {
    const { content, onSign, hidden, isLoading } = props;
    const { t } = useTranslation(['SignUP']);

    const [signableData, setSignableData] = useState<SignInfo[]>();

    const getSignableData = async (data: string[]) => {
        const request = new GetSignableDataDto();
        request.documents = data;
        request.signatureTypeCode = 'I';

        const client = TaxpayerProxy.getTaxpayerManagementPublicClient(true);
        try {
            const response = await client.getSignableData(request);
            if (response && response.documents) {
                setSignableData(response.documents);
            }
        } catch {;}
    };

    useEffect(() => {
        if (content.length || !hidden) {
            getSignableData(content);
        }
    }, [content, hidden]);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).componentCallback = (result: string) => {
        onSign(result);
    };

    useEffect(() => {
        const perform = async () => {
            const result = await handleDocument(signableData);
            if (result) {
                const root = document.getElementById(
                    'ITIDA-OPEN-CERT-STORE-BTN'
                );
                if (root?.click) {
                    root.click();
                }
            }
        };
        if (signableData?.length) {
            perform();
        }
    }, [signableData]);

    return (
        <div>
            <div>
                <Helmet>
                    <script type="text/javascript" src="/ITIDA-LOADER.js" />
                    <script type="text/javascript" src="/sha256.min.js" />
                    <script type="text/javascript" src="/sha256.js" />
                    <script type="text/javascript" src="/base64.js" />
                </Helmet>
            </div>

            {/* <link rel="stylesheet" href="/bootstrap.min.css" /> */}
            <form id="SigningForm">
                <div style={hidden ? { display: 'none' } : undefined}>
                    <div className="hidden">
                        <TextField
                            name="base64Value"
                            id="base64Value"
                            type="hidden"
                        />
                        <TextField
                            name="hashValue"
                            id="hashValue"
                            type="hidden"
                            value={signableData?.[0]?.shA256}
                        />
                    </div>
                    <PrimaryButton
                        menuIconProps={{ iconName: 'Handwriting' }}
                        text={t('SignDocument')}
                        id="ITIDA-OPEN-CERT-STORE-BTN"
                    >
                        {isLoading && <Spinner size={SpinnerSize.small} />}
                    </PrimaryButton>
                </div>
            </form>
        </div>
    );
};
